import React from 'react';
import PropTypes from 'prop-types';
import ViewerContent from './ViewerContent';
import withViewer from '../withViewer';
import { DOCUMENT_EXTERNAL_EVENTS } from '../../helpers/utils';

class InPageViewer extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    this.props.checkSignal(DOCUMENT_EXTERNAL_EVENTS.NEXT_STEP, () => {
      if (this.props.downloadRequired) {
        this.props.onShowDownloadRequiredDialog();
      } else if (
        this.props.confirmed ||
        this.props.document?.rejected ||
        this.props.documentIsScrolledTillEnd
      ) {
        this.props.onShowConfirmationDialog();
      }
    });
  }

  render() {
    return <ViewerContent {...this.props} showConfirmButton={false} />;
  }
}

InPageViewer.propTypes = {
  onShowDownloadRequiredDialog: PropTypes.func,
  onShowConfirmationDialog: PropTypes.func,
  checkSignal: PropTypes.func,
  document: PropTypes.object,
  documentIsScrolledTillEnd: PropTypes.bool,
  confirmed: PropTypes.bool,
  downloadRequired: PropTypes.bool
};
export default withViewer(InPageViewer);
